import { CloseIcon } from "../icons/Close";
import { Button } from "../ui/button";

export default function CloseIframeButton() {
    return <Button style={{ backgroundColor: "hsl(var(--sidebar-background))", visibility: "hidden" }} variant={"ghost"} className="rounded-full  shadow-sm" onClick={() => {
        (parent as any)?.closeIFrame();
    }} >
        <CloseIcon />
    </Button>
}